<button
  title="show calendar"
  [id]="buttonId"
  class="date-picker-icon-button"
  data-testid="datePickerButton"
>
  <ion-icon name="calendar"></ion-icon>
  <ion-icon name="caret-down" class="down"></ion-icon>
</button>

<ion-popover [trigger]="buttonId" [keepContentsMounted]="true">
  <ng-template>
    <ion-datetime
      data-testid="datePickerCalendar"
      [locale]="locale()"
      [presentation]="presentation()"
      value="{{ date | date: 'yyyy-MM-dd' }}"
      (ionChange)="onDateChange($event)"
      [min]="minDate ? (minDate | date: 'yyyy-MM-dd') : undefined"
      [max]="maxDate ? (maxDate | date: 'yyyy-MM-dd') : undefined"
      [showDefaultButtons]="true"
      [doneText]="'general_ok' | translate"
      [cancelText]="'general_cancel' | translate"
    >
    </ion-datetime>
  </ng-template>
</ion-popover>
